export const responseHandlerActionTypes = {
	RESPONSE: 'RESPONSE',
};
